import { useContext } from 'react'
import type { SettingsContextValue } from '../contexts/SettingsContext'
import SettingsContext from '../contexts/SettingsContext'

const useSettings = (): SettingsContextValue => useContext(SettingsContext)

export default useSettings
